/**
 * Do not edit directly
 */

export default "PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTYgOEwyMSAzTTIxIDNIMTZNMjEgM1Y4TTggOEwzIDNNMyAzTDMgOE0zIDNMOCAzTTggMTZMMyAyMU0zIDIxSDhNMyAyMUwzIDE2TTE2IDE2TDIxIDIxTTIxIDIxVjE2TTIxIDIxSDE2IiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz48L3N2Zz4=";